import type { LabradorTrackData } from "common-types";
import { send } from "./sender";
import { getGeoData } from "../../../../geo";
import { cookieManager, getExpBucket } from "utils";
import {
  getArticleId,
  getBeaconId,
  getPageLang,
  getSessionId,
  getTrackingPv,
  getTrackingPvGlobal,
  getTrackingPvUid,
  getUserId,
  getWikiId,
  getWikiName,
  getWikiSkin,
} from "../utils/beaconParams";
import type { LabradorKeyValueSenderBody } from "../types";

export async function sendLabradorKeyValues({
  payload,
}: Pick<LabradorTrackData, "payload">): Promise<void> {
  const nowDate = new Date();
  const geo = await getGeoData(cookieManager);
  const propValues = getPropValues(payload);

  // Do not send empty key values to DWH
  if (propValues === "") {
    return;
  }

  const body: LabradorKeyValueSenderBody = {
    timestamp: nowDate.getTime(),
    tz_offset: nowDate.getTimezoneOffset(),
    prop_value: payload.flags?.join(";") ?? "",
    country: geo.country,
    session_id: getSessionId(),
    pv_number: getTrackingPv(),
    pv_number_global: getTrackingPvGlobal(),
    pv_unique_id: getTrackingPvUid(),
    beacon: getBeaconId(),
    c: getWikiId(),
    x: getWikiName(),
    lc: getPageLang(),
    s: getWikiSkin(),
    ua: window.navigator.userAgent,
    u: getUserId(),
    a: getArticleId(),
    n: -1,
    exp_bucket: getExpBucket(),
  };

  send("adenglabradorinfo", body);
}

function getPropValues(payload: LabradorTrackData["payload"]): string {
  return payload.flags?.join(";") ?? "";
}
